"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingInformationRow = void 0;
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var AddCustomInvoicingAddress_1 = require("./AddCustomInvoicingAddress");
var ProjectInformation_1 = require("./ProjectInformation");
require("./style.scss");
var BillingEnhance = (0, recompose_1.compose)((0, recompose_1.lifecycle)({
    componentWillReceiveProps: function (nextProps) {
        var _a;
        if (nextProps.selected !== this.props.selected &&
            nextProps.selected &&
            nextProps.selected.type === 'INTERNAL' &&
            this.props.selected &&
            this.props.selected.type === 'INTERNAL') {
            if (nextProps.selected.projects &&
                nextProps.selected.projects.length === 1) {
                if (this.props.selected.selectedProject === undefined ||
                    nextProps.selected.selectedProject === undefined) {
                    nextProps.setBillingInformation(__assign(__assign({}, nextProps.selected), { selectedProject: nextProps.selected.projects[0].id }));
                }
                if (this.props.selected.selectedProject !==
                    nextProps.selected.selectedProject &&
                    nextProps.selected.projects &&
                    nextProps.selected.projects.length === 1) {
                    nextProps.setBillingInformation(__assign(__assign({}, nextProps.selected), { selectedProject: nextProps.selected.projects[0].id }));
                }
            }
        }
        if (((_a = nextProps.selected) === null || _a === void 0 ? void 0 : _a.type) === 'INTERNAL' &&
            (!this.props.selected ||
                (this.props.selected && this.props.selected.type === 'CUSTOM'))) {
            if (nextProps.selected.projects &&
                nextProps.selected.projects.length === 1) {
                nextProps.setBillingInformation(__assign(__assign({}, nextProps.selected), { selectedProject: nextProps.selected.projects[0].id }));
            }
        }
    }
}), (0, recompose_1.onlyUpdateForKeys)([
    'billingInformation',
    'customBillingInformation',
    'selected'
]), recompose_1.pure);
var customBillingInfo = function (billing) {
    if (!billing) {
        return (0, translation_1.getLocalization)('userfront/customBillingInformation//selectBillingInformation');
    }
    if (billing.type === 'INTERNAL') {
        return billing.customerName;
    }
    return (0, translation_1.getLocalization)('userfront/customBillingInformation/customBillingInfo');
};
var getError = function (index, e) {
    return e.foldL(function () { return React.createElement("span", { key: "validation-".concat(index), className: 'validation-error' }); }, function (errors) {
        if (errors[index] && errors[index].length > 0) {
            return (React.createElement("span", { key: "validation-".concat(index), className: 'validation-error' }, errors[index][0]));
        }
        return React.createElement("span", { key: "validation-".concat(index), className: 'validation-error' });
    });
};
var Billing = BillingEnhance(function (props) {
    var customBillingInformation = {
        type: 'CUSTOM',
        id: -1,
        customerName: '',
        streetAddress: '',
        postalCode: '',
        referenceNumber: '',
        city: ''
    };
    return (React.createElement(sok_ui_1.Dropdown2, { className: 'select-billing-information' },
        React.createElement(sok_ui_1.TextInput, { className: 'select', editable: false, disabled: props.disable, iconRight: React.createElement("span", { className: 'icon-container' },
                React.createElement(Icon_1.Icon, { className: 'fa-chevron-down' })), value: customBillingInfo(props.selected) }),
        React.createElement(sok_ui_1.Dropdown2Menu, null,
            React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () { return props.setBillingInformation(customBillingInformation); } }, customBillingInfo(customBillingInformation)),
            props.items.map(function (x) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () { return props.setBillingInformation(x); } }, customBillingInfo(x))); }))));
});
var BillingInformationRow = function (props) {
    return (React.createElement("div", { className: 'billing-information' },
        React.createElement(sok_ui_1.Row, null,
            React.createElement(sok_ui_1.Column, { small: 3 },
                React.createElement("label", { htmlFor: 'billing-information' }, (0, translation_1.getLocalization)('userfront/customBillingInformation//billingInformation'))),
            React.createElement(sok_ui_1.Column, { small: 9 },
                props.disable ? (React.createElement(sok_ui_1.TextInput, { className: 'select', editable: false, disabled: props.disable, iconRight: React.createElement("span", { className: 'icon-container' },
                        React.createElement(Icon_1.Icon, { className: 'fa-chevron-down' })), value: customBillingInfo(props.selected) })) : (React.createElement(Billing, __assign({}, props))),
                props.errors && getError('billingInformation', props.errors))),
        props.selected !== undefined && props.selected.type === 'CUSTOM' && (React.createElement(sok_ui_1.Row, null,
            React.createElement(sok_ui_1.Column, { extraSmall: 12 },
                React.createElement(AddCustomInvoicingAddress_1.default, __assign({}, props))))),
        props.selected !== undefined &&
            props.selected.type === 'INTERNAL' &&
            props.selected.projects &&
            props.selected.projects.length > 0 && (React.createElement(sok_ui_1.Row, null,
            React.createElement(sok_ui_1.Column, { extraSmall: 12 },
                React.createElement(ProjectInformation_1.default, __assign({}, props)))))));
};
exports.BillingInformationRow = BillingInformationRow;
exports.default = exports.BillingInformationRow;
